import play from '../assets/mt_play.svg';
import pause from '../assets/mt_pause.svg';
import volumeUp from '../assets/mt_volume-up.svg';
import volumeDown from '../assets/mt_volume-down.svg';
import volumeOff from '../assets/mt_volume-off.svg';
import full from '../assets/mt_full.svg';
import fullWeb from '../assets/mt_full-web.svg';
import setting from '../assets/mt_setting.svg';
import right from '../assets/right.svg';
import comment from '../assets/comment.svg';
import commentOff from '../assets/comment-off.svg';
import send from '../assets/send.svg';
import pallette from '../assets/pallette.svg';
import camera from '../assets/mt_camera.svg';
import subtitle from '../assets/subtitle.svg';
import loading from '../assets/mt_loading.svg';
import light from '../assets/mt_light.svg';
import light_off from '../assets/mt_off.svg';
import light_on from '../assets/mt_on.svg';
import pictureinpicture from '../assets/mt_picture-in-picture.svg';
import endlogo from '../assets/end_logo.svg';
import isright from '../assets/mt_right.svg';
import tips from '../assets/mt_tips.svg';
var Icons = {
    play: play,
    pause: pause,
    volumeUp: volumeUp,
    volumeDown: volumeDown,
    volumeOff: volumeOff,
    full: full,
    fullWeb: fullWeb,
    setting: setting,
    right: right,
    comment: comment,
    commentOff: commentOff,
    send: send,
    pallette: pallette,
    endlogo: endlogo,
    camera: camera,
    subtitle: subtitle,
    loading: loading,
    pictureinpicture: pictureinpicture,
    light: light,
    light_off: light_off,
    light_on: light_on,
    tips: tips,
    isright: isright
};
export default Icons;